<template>
  <div class="homebg">
     <div class="home_top">
         <div class="home_top_img"><img src="../assets/img/home.png" /></div>
         <div class="personal">
           <el-dropdown :show-timeout="0" size="small" placement="bottom" >
             <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
               <div class="user_img">
                   <img v-if="userImg && userImg != 'null'"
                        :src="userImg"
                        style="height: 3.3rem;width: 3.3rem; border-radius: 50% 50%"/>
                    <img
                      v-else
                      style="height: 3.3rem"
                      src="../assets/img/default-header.png"
                      :alt="userName"
                    />
               </div>
               <span style="color: white;margin-left: 10px" :title="userName" class="name">{{userName}}</span>
             </div>

             <el-dropdown-menu slot="dropdown" style="width: 110px">
               <el-dropdown-item @click.native="userMessage()">个人中心</el-dropdown-item>
               <el-dropdown-item @click.native="logoutHandle()">退出登录</el-dropdown-item>
             </el-dropdown-menu>
           </el-dropdown>
         </div>
     </div>
     <div class="container">
          <div class="container_wrap">
             <div class="list " v-for="(item,index) in appLists" :key="index" @click="onApplication(item)" :class="24>index>=0?'bg'+index:'bg24'">
                 <img :src="item.icon" />
                 <div class="text">
                      {{item.name}}
                 </div>
             </div>
          </div>
     
     </div>
  </div>
</template>
<script>
import Vue from "vue";
import { loginOut, listApplication, bindingPcWechat } from "@/api/api";
import { clearLoginInfo } from "@/utils";
import wxlogin from "vue-wxlogin";
export default {
  data() {
    return {
      imgUrl: process.env.IMG_SHOW_URL + "/",
      userImg: this.$cookie.get("headImg"),
      userName: this.$cookie.get("name"),
      typeLists: ["全部"],
      typeName: "全部",
      typeIndex: 0,
      title: "",
      appLists: [],
      appLists2: [],
      appLists3: [],
      allApplication: [],
      code: "",
      wxConfig: {
        appid: process.env.WX_APPID,
        wxVisible: false,
      },
      userType: this.$cookie.get("userType"),  // 1老师  2 学生
    };
  },
  mounted() {
    this.listApplication();
    if (typeof this.$route.query.returnType != "undefined") {
      let returnType = this.$route.query.returnType;
      this.code = this.$route.query.code;
      if (returnType == "binding") {
        //微信绑定
        this.bindingPcWechat();
      }
    }
  },
  components: {
    wxlogin,
  },
  methods: {
    bindingPcWechat() {
      bindingPcWechat({
        code: this.code,
        userId: this.$cookie.get("userId"),
      }).then((res) => {
        if (res && res.code === 0) {
          this.$message.success("微信绑定成功");
          this.$cookie.set("pcOpenid", res.data);
          this.wxConfig.wxVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    logoutHandle() {
      loginOut({
        token: this.$cookie.get("token"),
      }).then((res) => {
        if (res && res.code === 0) {
          this.$message.success("退出登录成功");
          clearLoginInfo();
          this.$router.push({ path: "/login" });
        } else {
          this.$message.success("退出登录成功");
          clearLoginInfo();
          this.$router.push({ path: "/login" });

        }
      });
    },
    userMessage() {
      // this.$router.push({ path: "/personal" });
      if(this.userType == 1){
           // 老师
          localStorage.setItem('isCheck', 2)
          window.open('https://jbzk.ejkj.top/userCenter/#/disk', '_blank');
      }else{
          // 学生
          localStorage.setItem('isCheck', 1)
          window.open('https://jbzk.ejkj.top/userCenter/#/user', '_blank');
      }
    },
    changeApp(index) {
      this.typeIndex = index;
      this.typeName = this.typeLists[this.typeIndex];
      this.searchApplication();
    },
    listApplication() {
      listApplication({}).then((res) => {
        if (res && res.code === 0) {
          this.appLists = res.data;
          // if(this.allApplication.length>4){
          //   for (let i = 0; i < 4; i++) {
          //     this.appLists.push(this.allApplication[i])
          //   }
          //   if(this.allApplication.length>4){
          //     if(this.allApplication.length<8){
          //       for (let i = 4; i < this.allApplication.length; i++) {
          //          this.appLists2.push(this.allApplication[i])
          //        }
          //     }else{
          //       for (let i = 4; i < 8; i++) {
          //          this.appLists2.push(this.allApplication[i])
          //       }
          //       for (let i = 8; i < this.allApplication.length; i++) {
          //         this.appLists3.push(this.allApplication[i])
          //       }
          //     }
          //   }else{
          //     for (let i = 4; i < this.allApplication.length; i++) {
          //       this.appLists2.push(this.allApplication[i])
          //     }
          //   }
          // }else{
          //   this.appLists = this.allApplication
          // }
        } else {
          this.$message.error(res.msg);
          this.$router.push({ path: '/login' })
        }
      });
    },
    onApplication(item) {
      localStorage.setItem('account',this.$cookie.get("account"))
      if(item.suffix){
        // window.location.href = item.url + "?" + item.suffix;
        window.open(item.url + "?" + item.suffix,"_blank")
      }else{
       // window.location.href = item.url + "?token=" + Vue.cookie.get("token");
       //  window.open(item.url + "?token=" + Vue.cookie.get("token"),"_blank")
        window.open(item.url,"_blank")
      }
    },
  },
};
</script>
<style scoped lang="scss">
.homebg{
height: 100vh;
background-image: url("../assets/newimg/bg1.jpg");
background-size: cover;
display: flex;
flex-direction: column;
overflow: hidden;
}
.home_top{
height: 8.33rem;
background: rgba(1,49,130,0.8);
border-radius: 0px 0px 0px 0px;
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-between;
width: 100%;
.home_top_img{
 margin-left: 5rem;
 img{
  height: 6.67rem;
 }
}
.personal {
 right: 3.2rem;
 top: 0.7rem;
 color: #fff;
 height: 5rem;
 line-height: 5rem;
 margin-right: 5rem;
 cursor: pointer;
 .el-dropdown-link {
   width: 10rem;
   display: flex;
   justify-content: space-between;
   align-items: center;
   color: white;
 }
 .user_img{
     display: flex;
 }
 .name{
     max-width: 10rem;
     white-space: nowrap;
     text-overflow: ellipsis;
     overflow: hidden;
     font-size: 1.2rem;
 }
}
}
.container{
 padding-top: 3.17rem;
 overflow: auto;
 display: flex;
 justify-content: center;
 align-items: center;
 height: calc(100vh - 8.33rem);
 .container_wrap{
     max-height: calc(100vh - 11.5rem);
     max-width: 130.02rem;
     margin: 0 auto;
     display: flex;
     flex-direction: row;
     flex-flow: row wrap;
 }
 .list{
     width: 21.67rem;
     height: 20.42rem;
     display: flex;
     flex-direction: column;
     align-items: center;
     cursor: pointer;
     img{
         width: 6.33rem;
         height: 6.33rem;
         margin-top: 5.03rem;
         margin-bottom: 0.53rem;
     }
     .text{
         width: 12rem;
         text-align: center;
         font-size: 2rem;
         font-family: PingFang SC, PingFang SC;
         color: #FFFFFF;
         line-height: 2.67rem;
     }
 }
}
.bg0{
 background: rgba(1, 49, 130, 0.6);
}
.bg0:hover{
 background: rgba(1, 49, 130, 0.8);
}
.bg1{
 background: rgba(21, 115, 252, 0.6);
}
.bg1:hover{
 background: rgba(21, 115, 252, 0.8);
}
.bg2{
 background: rgba(1, 49, 130, 0.6);
}
.bg2:hover{
 background: rgba(1, 49, 130, 0.8);
}
.bg3{
 background: rgba(255, 169, 39, 1);
}
.bg3:hover{
 background: rgba(255, 169, 39, 0.8);
}
.bg4{
 background: rgba(1, 49, 130, 0.6);
}
.bg4:hover{
 background: rgba(1, 49, 130, 0.8);
}
.bg5{
 background: rgba(21, 115, 252,0.6);
}
.bg5:hover{
 background: rgba(21, 115, 252,0.8);
}
.bg6{
 background: rgba(27, 99, 183, 0.6);
}
.bg6:hover{
 background: rgba(27, 99, 183, 0.8);
}
.bg7{
 background: rgba(255, 169, 39, 1);
}
.bg7:hover{
 background: rgba(255, 169, 39, 0.8);
}
.bg8{
 background: rgba(27, 99, 183, 0.6);
}
.bg8:hover{
 background: rgba(27, 99, 183, 0.8);
}
.bg9{
 background: rgba(1, 49, 130, 1);
}
.bg9:hover{
 background: rgba(1, 49, 130, 0.8);
}
.bg10{
 background: rgba(27, 99, 183, 0.6);
}
.bg10:hover{
 background: rgba(27, 99, 183, 0.8);
}
.bg11{
 background: rgba(1, 49, 130, 0.6);
}
.bg11:hover{
 background: rgba(1, 49, 130, 0.8);
}
.bg12{
 background: rgba(1, 49, 130, 0.6);
}
.bg12:hover{
 background: rgba(1, 49, 130, 0.8);
}
.bg13{
 background: rgba(21, 115, 252, 0.6);
}
.bg13:hover{
 background: rgba(21, 115, 252, 0.8);
}
.bg14{
 background: rgba(1, 49, 130, 0.6);
}
.bg14:hover{
 background: rgba(1, 49, 130, 0.8);
}
.bg15{
 background: rgba(21, 115, 252, 0.6);
}
.bg15:hover{
 background: rgba(21, 115, 252, 0.8);
}
.bg16{
 background: rgba(255, 169, 39, 1);
}
.bg16:hover{
 background: rgba(255, 169, 39, 0.8);
}
.bg17{
 background: rgba(27, 99, 183, 0.6);
}
.bg17:hover{
 background: rgba(27, 99, 183, 0.8);
}
.bg18{
 background: rgba(35, 104, 206, 0.6);
}
.bg18:hover{
 background: rgba(35, 104, 206, 0.8);
}
.bg19{
 background: rgba(1, 49, 130, 0.60);
}
.bg19:hover{
 background: rgba(1, 49, 130, 0.8);
}
.bg20{
 background: rgba(255, 169, 39, 1);
}
.bg20:hover{
 background: rgba(255, 169, 39, 0.8);
}
.bg21{
 background: rgba(27, 99, 183, 0.6);
}
.bg21:hover{
 background: rgba(27, 99, 183, 0.8);
}
.bg22{
 background: rgba(1, 49, 130, 0.6);
}
.bg22:hover{
 background: rgba(1, 49, 130, 0.8);
}
.bg23{
 background: rgba(31, 102, 204, 0.6);
}
.bg23:hover{
 background: rgba(31, 102, 204, 0.8);
}
.bg24{
 background: rgba(1, 49, 130, 0.6);
}
.bg24:hover{
 background: rgba(1, 49, 130, 0.8);
}
.container::-webkit-scrollbar {
width: 10px;
height: 10px;
}

.container::-webkit-scrollbar-thumb {
background: linear-gradient(to bottom right, rgba(1, 49, 130, 0.5) 0%, rgba(1, 49, 130, 0.5) 100%);
border-radius: 5px;
}

.container::-webkit-scrollbar-track {
background-color: rgba(1, 49, 130, 0.2);
border: 1px solid rgba(1, 49, 130, 0.2);
}

.container::-webkit-scrollbar-button {
background-color: rgba(1, 49, 130, 0.5);
border-radius: 3px;
}

.container::-webkit-scrollbar-button:hover {
background-color: #999999;
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue